import { Component, OnInit } from '@angular/core';
import { PlmService } from 'src/app/shared/services/plm.service';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';

@Component({
  selector: 'app-plm-closure',
  templateUrl: './plm-closure.component.html',
  styleUrls: ['../plm-shared.css'],
})
export class PlmClosureComponent implements OnInit {
  projects: any[] = [];
  locations: any[] = [];
  workItems: any[] = [];
  projectId: number | null = null;
  tests: any[] = [];
  wccs: any[] = [];
  invoices: any[] = [];
  handovers: any[] = [];
  testForm: any = { work_location_id: '', pavement_work_item_id: '', test_type: 'density', result_value: '', uom: '%', pass: true };
  wccForm: any = { work_location_id: '', wcc_no: '', notes: '' };
  invForm: any = { invoice_id: '', wcc_id: '', work_location_id: '', amount: '' };
  hoForm: any = { receiving_authority: '', handover_date: '', om_contractor_vendor_id: '', notes: '' };

  constructor(private plm: PlmService, private api: ApiService, private toastr: ToastrMsgService) {}

  ngOnInit(): void {
    this.api.getProjectCommonAll({ page: 1, limit: 200 }).subscribe({
      next: (res: any) => (this.projects = res?.data || []),
    });
    this.reload();
  }

  onProject(): void {
    const q = { project_id: this.projectId || undefined };
    this.plm.listWorkLocations(q).subscribe({ next: (r: any) => (this.locations = r.data || []) });
    this.plm.listPavementWork(q).subscribe({ next: (r: any) => (this.workItems = r.data || []) });
    this.reload();
  }

  reload(): void {
    const q = { project_id: this.projectId || undefined };
    this.plm.listAcceptance(q).subscribe({ next: (r: any) => (this.tests = r.data || []) });
    this.plm.listWcc(q).subscribe({ next: (r: any) => (this.wccs = r.data || []) });
    this.plm.listInvoiceLinks(q).subscribe({ next: (r: any) => (this.invoices = r.data || []) });
    this.plm.listHandover(q).subscribe({ next: (r: any) => (this.handovers = r.data || []) });
  }

  addTest(): void {
    this.plm.createAcceptance({ ...this.testForm, project_id: this.projectId }).subscribe({
      next: () => {
        this.toastr.success('Acceptance test recorded');
        this.reload();
      },
      error: (e) => this.toastr.error(e?.error?.message || 'Failed'),
    });
  }

  addWcc(): void {
    this.plm.createWcc({ ...this.wccForm, project_id: this.projectId }).subscribe({
      next: () => {
        this.toastr.success('WCC drafted');
        this.reload();
      },
      error: (e) => this.toastr.error(e?.error?.message || 'Failed'),
    });
  }

  issue(row: any): void {
    this.plm.issueWcc(row.id).subscribe({
      next: () => {
        this.toastr.success('WCC issued');
        this.reload();
      },
      error: (e) => this.toastr.error(e?.error?.message || 'Failed'),
    });
  }

  addInvoice(): void {
    this.plm.createInvoiceLink({ ...this.invForm, project_id: this.projectId }).subscribe({
      next: () => {
        this.toastr.success('Invoice linked to accepted work');
        this.reload();
      },
      error: (e) => this.toastr.error(e?.error?.message || 'Failed'),
    });
  }

  addHandover(): void {
    this.plm.createHandover({ ...this.hoForm, project_id: this.projectId }).subscribe({
      next: () => {
        this.toastr.success('Handover package created');
        this.reload();
      },
      error: (e) => this.toastr.error(e?.error?.message || 'Failed'),
    });
  }
}
